import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Col, Row, Button, Radio, Icon, Spin } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next'
import { withIdentity, IdentityProps } from '../../../../core/services/authentication';
import HttpService from '../../../../core/services/http.service';
import { resolve } from '../../../../inversify.config';
import autobind from 'autobind-decorator';
import { WhatsNewReportItem } from '../../../../stores/whats-new-store'

interface WhatsNewReportViewProps extends WithTranslation {
    showManagerContent: boolean
    reload: boolean
}

interface WhatsNewReportViewState {
    isBusy: boolean
    text: string
}


class WhatsNewReportUserView extends React.Component<WhatsNewReportViewProps, WhatsNewReportViewState> {
    @resolve(HttpService)
    private httpService!: HttpService;

    constructor(props: WhatsNewReportViewProps) {
        super(props);
        this.state = {
            isBusy: false,
            text: props.t("Nothing to show"),
        }
    }

    componentDidMount() {
        this.load()
    }

    componentDidUpdate(prevProps: WhatsNewReportViewProps) {
        if (this.props.t !== prevProps.t || (this.props.reload && this.props.reload != prevProps.reload)) {
            this.load()
        }
    }

    @autobind
    private async load() {
        this.setState({ isBusy:true })
        this.httpService.get<WhatsNewReportItem>(`${process.env.PUBLIC_URL}/api/v1/whatsnew/language/${this.props.i18n.language}`).then((result) => {
            this.setState({ isBusy: false, text: this.props.showManagerContent ? result.data.adminText : result.data.text })
        }).catch(() => {
            this.setState({ isBusy: false, text: this.props.t("Nothing to show") })
        })
    }

    public render() {
        return <Spin spinning={this.state.isBusy}>
            <p dangerouslySetInnerHTML={{ __html: this.state.text }}></p>
        </Spin>

    }
}
export default withTranslation()(WhatsNewReportUserView as any) as any
